import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 text-center lg:text-left">
        <div>
        <h4 className="text-xl text-[#4A4A4A] sm:text-2xl font-extrabold mb-3 sm:mb-4">Lash Studio</h4>
            <a href="sms:+19294029144">            
          <p className="text-gray-700 flex items-center justify-center lg:justify-start text-sm sm:text-base"><span className="mr-2">📞</span> 929-402-9144</p></a>
          <a href="sms:+16468203551">
          <p className="text-gray-700 flex items-center justify-center lg:justify-start text-sm sm:text-base"><span className="mr-2">📞</span> 646-820-3551</p></a>
          <p className="text-gray-700 mt-2 underline text-sm sm:text-base">
            <a href="https://maps.app.goo.gl/DtzAQk6WjQgCTjoE7" target="_blank" rel="noopener noreferrer">
              36-14 164th St, Flushing, NY 11358
            </a>
          </p>
          <h5 className="mt-4 text-md sm:text-lg font-semibold">Hours</h5>
          <ul className="text-gray-700 text-sm sm:text-base">
            <li>M-F: 10:00 AM - 7:00 PM</li>
            <li>Sat: 10:00 AM - 5:00 PM</li>
            <li>Sun: 10:00 AM - 5:00 PM</li>
          </ul>
        </div>
        <div>
          <iframe
            title="Lash Studio Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.9913628705935!2d-73.80201749999999!3d40.7622147!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2611557c9d6d7%3A0x714700b49383cc7b!2sLash%20studio!5e0!3m2!1sen!2sus!4v1739249453508!5m2!1sen!2sus"
            width="100%"
            height="250"
            className="rounded-md"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </footer>
  );
}



